<template>
    <div class="left-side-horizontal-options-holder">
        <div v-if='google && map'>
            <AutocompleteSearchbox class="left-side-search-box" v-bind:google="google"
                                   v-bind:map="map"></AutocompleteSearchbox>
        </div>
        <OptionPicker class="left-side-widget-radius" v-model="options.radius" v-bind:options="radius_options"></OptionPicker>
    </div>
</template>


<script>

    import AutocompleteSearchbox from "./AutocompleteSearchbox";
    import OptionPicker from "./OptionPicker";

    export default {
        name: "ContentLeftSideWidgedHolder",
        components: {OptionPicker, AutocompleteSearchbox},
        props: ["google", "map", "value"],
        data() {
            return {
                wow: {
                    "address_components": [{
                        "long_name": "Jena",
                        "short_name": "J",
                        "types": ["locality", "political"]
                    }, {
                        "long_name": "Thuringia",
                        "short_name": "TH",
                        "types": ["administrative_area_level_1", "political"]
                    }, {"long_name": "Germany", "short_name": "DE", "types": ["country", "political"]}],
                    "html_attributions": []
                },
                options: this.value,
                radius_options: {
                    "500 m": "500",
                    "1 km": "1000",
                    "2 km": "2000",
                    "5 km": "5000",
                },
                isVisible: false,
            }
        },
        watch: {
            options: function(newValue) {
                this.$emit("input", newValue)
            }
        },
        mounted() {

        },
    }
</script>

<style scoped lang="scss">
    .left-side-horizontal-options-holder {
        position: absolute;
        z-index: 5;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;
    }

    .left-side-search-box {
        display: flex;
        justify-content: center;
        flex-grow: 1;
        order: 1;
    }
</style>